import { Link } from 'react-router-dom';
import { movies, hotRanking } from '@/mocks/movies';

export default function HotRanking() {
  const rankedMovies = hotRanking
    .map((id) => movies.find((m) => m.id === id)!)
    .filter(Boolean);

  return (
    <section className="py-12 md:py-16 bg-background-100/40">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <div>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
                热门排行榜
              </h3>
              <p className="text-sm text-foreground-500 mt-1">根据用户评分和热度综合排名</p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              完整榜单
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
            {rankedMovies.map((movie, index) => (
              <Link
                key={movie.id}
                to={`/category/${movie.category}`}
                className="flex items-center gap-3 md:gap-4 p-3 md:p-4 rounded-xl bg-background-100/60 border border-background-300/20 hover:border-primary-500/30 hover:bg-background-200/40 transition-all duration-300 group cursor-pointer"
              >
                <div className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-heading font-bold text-sm md:text-base ${
                  index < 3
                    ? 'bg-accent-500/20 text-accent-400'
                    : 'bg-background-300/30 text-foreground-400'
                }`}>
                  {index + 1}
                </div>
                <div className="w-12 h-16 md:w-14 md:h-20 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={movie.posterUrl}
                    alt={movie.title}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm md:text-base font-semibold text-foreground-100 truncate group-hover:text-primary-400 transition-colors">
                    {movie.title}
                  </h4>
                  <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">
                    {movie.director} / {movie.year}
                  </p>
                </div>
                <div className="flex-shrink-0 flex items-center gap-1 text-accent-400">
                  <i className="ri-star-fill text-sm"></i>
                  <span className="text-sm font-bold">{movie.rating}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}